"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Chip_1 = tslib_1.__importDefault(require("@material-ui/core/Chip"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var clsx_1 = tslib_1.__importDefault(require("clsx"));
var Icon_1 = require("../Icon");
var Tag = function (_a) {
    var label = _a.label, isActive = _a.isActive, onClick = _a.onClick, anchorEl = _a.anchorEl, setAnchorEl = _a.setAnchorEl, variant = _a.variant, hasDropdown = _a.hasDropdown, count = _a.count, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var showCount = count > 0;
    var content = (react_1.default.createElement(StyledContainer, null,
        react_1.default.createElement("span", null, label),
        showCount && (react_1.default.createElement(StyledCount, { className: clsx_1.default({
                active: isActive,
                dropdownOpen: anchorEl,
                disabled: disabled,
            }), variant: variant, "data-testid": "tag-dropdown-count" }, count))));
    var dropdownArrow = (react_1.default.createElement(react_1.default.Fragment, null, anchorEl ? react_1.default.createElement(Icon_1.Icon, { name: "menu_up" }) : react_1.default.createElement(Icon_1.Icon, { name: "menu_down" })));
    var onArrowClick = function (e) {
        return anchorEl
            ? setAnchorEl(null)
            : setAnchorEl(e.currentTarget.previousElementSibling);
    };
    return (react_1.default.createElement(StyledContainer, null,
        react_1.default.createElement(StyledChip, { className: clsx_1.default({
                active: isActive,
                hasDropdown: hasDropdown,
                showCount: showCount,
                dropdownOpen: anchorEl,
                disabled: disabled,
            }, 'main-chip'), variant: variant, label: content, classes: { label: 'label', deletable: 'deletable' }, onClick: onClick, disableRipple: true, "data-testid": "tag-dropdown-main-tag", disabled: disabled }),
        hasDropdown && (react_1.default.createElement(StyledChip, { className: clsx_1.default({ active: isActive, dropdownOpen: anchorEl }, 'dropdown-chip'), variant: variant, label: dropdownArrow, classes: { label: 'label', deletable: 'deletable' }, onClick: onArrowClick, disableRipple: true, "data-testid": "tag-dropdown-arrow-tag", disabled: disabled }))));
};
exports.default = Tag;
var StyledChip = styled_components_1.default(function (_a) {
    var variant = _a.variant, rest = tslib_1.__rest(_a, ["variant"]);
    return react_1.default.createElement(Chip_1.default, tslib_1.__assign({}, rest));
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    border-radius: 0.4rem;\n    padding: 0.4rem 0.6rem;\n    height: auto;\n    background-color: ", ";\n    font-family: ", ";\n    color: ", ";\n    font-size: 1.2rem;\n    line-height: 1.6rem;\n    border: 1px solid\n      ", ";\n\n    &:active {\n      box-shadow: none;\n    }\n\n    &:hover {\n      background-color: ", ";\n      filter: ", ";\n    }\n\n    &:focus {\n      background-color: ", ";\n    }\n\n    &.dropdownOpen {\n      background-color: ", ";\n      color: ", ";\n      border: 1px solid ", ";\n    }\n\n    &.active {\n      background-color: ", ";\n      color: ", ";\n      border: 1px solid ", ";\n    }\n\n    &.active.dropdownOpen {\n      filter: brightness(0.9) saturate(3);\n      border: 1px solid ", ";\n      &.main-chip {\n        border-right: 0;\n      }\n      &.dropdown-chip {\n        border-left: 0;\n      }\n    }\n\n    & .label {\n      padding: 0;\n    }\n\n    &.hasDropdown {\n      border-radius: 0.4rem 0rem 0rem 0.4rem;\n      padding: 0.4rem 0.4rem 0.4rem 0.6rem;\n    }\n\n    &.showCount {\n      padding: 0.4rem 0.4rem 0.4rem 0.6rem;\n    }\n\n    &.dropdown-chip {\n      border-left: 0;\n      padding: 0.3rem 0.15rem;\n      border-radius: 0rem 0.4rem 0.4rem 0rem;\n      i {\n        font-size: 1.8rem;\n      }\n      &.active {\n        background-color: ", ";\n      }\n    }\n  }\n"], ["\n  && {\n    border-radius: 0.4rem;\n    padding: 0.4rem 0.6rem;\n    height: auto;\n    background-color: ",
    ";\n    font-family: ", ";\n    color: ",
    ";\n    font-size: 1.2rem;\n    line-height: 1.6rem;\n    border: 1px solid\n      ",
    ";\n\n    &:active {\n      box-shadow: none;\n    }\n\n    &:hover {\n      background-color: ",
    ";\n      filter: ",
    ";\n    }\n\n    &:focus {\n      background-color: ",
    ";\n    }\n\n    &.dropdownOpen {\n      background-color: ", ";\n      color: ", ";\n      border: 1px solid ", ";\n    }\n\n    &.active {\n      background-color: ", ";\n      color: ", ";\n      border: 1px solid ", ";\n    }\n\n    &.active.dropdownOpen {\n      filter: brightness(0.9) saturate(3);\n      border: 1px solid ", ";\n      &.main-chip {\n        border-right: 0;\n      }\n      &.dropdown-chip {\n        border-left: 0;\n      }\n    }\n\n    & .label {\n      padding: 0;\n    }\n\n    &.hasDropdown {\n      border-radius: 0.4rem 0rem 0rem 0.4rem;\n      padding: 0.4rem 0.4rem 0.4rem 0.6rem;\n    }\n\n    &.showCount {\n      padding: 0.4rem 0.4rem 0.4rem 0.6rem;\n    }\n\n    &.dropdown-chip {\n      border-left: 0;\n      padding: 0.3rem 0.15rem;\n      border-radius: 0rem 0.4rem 0.4rem 0rem;\n      i {\n        font-size: 1.8rem;\n      }\n      &.active {\n        background-color: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark' ? theme.colors.NTDarkGrey[900] : theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoRegular;
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark' ? theme.colors.white : theme.colors.NTDarkGrey[900];
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark'
        ? theme.colors.aqua[700]
        : theme.colors.NTDarkGrey[200];
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark' ? '#5B5C5C' : theme.colors.white;
}, function (_a) {
    var variant = _a.variant;
    return variant === 'dark' ? 'none' : 'brightness(0.9) saturate(3)';
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark' ? theme.colors.NTDarkGrey[900] : theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[50];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.aqua[700];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.aqua[700];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.aqua[700];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.aqua[700];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.aqua[200];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.aqua[800];
});
var StyledCount = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-size: 1rem;\n  line-height: 1.6rem;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 10rem;\n  padding: 0 0.45rem;\n  margin-left: 0.4rem;\n\n  &.active,\n  &.dropdownOpen {\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  font-family: ", ";\n  font-size: 1rem;\n  line-height: 1.6rem;\n  background-color: ",
    ";\n  color: ",
    ";\n  border-radius: 10rem;\n  padding: 0 0.45rem;\n  margin-left: 0.4rem;\n\n  &.active,\n  &.dropdownOpen {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark'
        ? theme.colors.NTDarkGrey[700]
        : theme.colors.NTDarkGrey[100];
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === 'dark' ? theme.colors.white : theme.colors.NTDarkGrey[900];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.aqua[800];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
});
var StyledContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
